import { Policy } from "../objects/policy";

// REACT_APP_API_QUOTE_SAVE=api/v1/quote/save
// REACT_APP_API_QUOTE_RATE=api/v1/quote/rate
// REACT_APP_API_QUOTE_RULES=api/v1/quote/rules/run
// REACT_APP_API_QUOTE_SERIALIZE=api/v1/quote/{quotenum}/serialize

export class RatingService {
    private ratingApiUrl: string;
    private rulesApiUrl: string;

    constructor(){
        var baseApi = process.env.REACT_APP_BASE_API_URL;
        var ratingApi = process.env.REACT_APP_API_QUOTE_RATE ?? "";
        var rulesApi = process.env.REACT_APP_API_QUOTE_RULES ?? "";

        this.ratingApiUrl = baseApi + ratingApi;
        this.rulesApiUrl = baseApi + rulesApi;
    }

    async Rate(quote: Policy) {
        var rquote = {...quote};
        rquote.raterName = (process.env.REACT_APP_CLIENT ?? "REACT-UI") + "-UI";
        rquote.mgaName = (process.env.REACT_APP_CARRIERID ?? "IITC");

        var modifiedVehicles = [...rquote.vehicles];
        var deDupedVehicles = modifiedVehicles.filter((original, index, self)=> {
            return index === self.findIndex((target) => (
                target.vin === original.vin
                ));
        });

        var modifiedDrivers = [...rquote.drivers];
        var deDupedDrivers = modifiedDrivers.filter((original, index, self)=> {
            return index === self.findIndex((target) => (
                target.firstName === original.firstName && target.lastName == original.lastName
                ));
        });

        rquote.vehicles = deDupedVehicles;
        rquote.drivers = deDupedDrivers;

        var jsonRequest = JSON.stringify(rquote);

        return fetch(this.ratingApiUrl,
            {
                mode: "cors",
                method: "POST",
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/json",
                    "pace-api-key": (process.env.REACT_APP_API_KEY ?? "")
                },
                body: jsonRequest
            })
    }
}